import { Logo as ComponentLogo } from '@a0/docs-components/ui/Header/Logo';
import { NavLink } from 'fluxible-router';
import * as React from 'react';
export var Logo = function () { return (React.createElement(NavLink, { href: "/docs" },
    React.createElement(ComponentLogo, null))); };
